module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-up-e28d5104f0b621f248f8da2794da1058.svg";